module.exports = __webpack_public_path__ + "static/media/globo.9a199f66.svg";